module.exports = __webpack_public_path__ + "static/media/2_2.ab825b39.png";